import { z4 } from '@fiverr-private/forms';
import { EMAIL_REGEX, FIVERR_ALLOWED_SUFFIX, FIVERR_DOMAIN } from '../../constants';
import { appTranslate } from '../../i18n';

export const createSchema = () =>
    z4.object({
        email: z4
            .email({ error: appTranslate<string>('errors.validation.email.incomplete') })
            .regex(EMAIL_REGEX, { error: appTranslate<string>('errors.validation.email.incomplete') })
            .refine(
                (email) =>
                    email.endsWith(FIVERR_DOMAIN) || email.includes(FIVERR_ALLOWED_SUFFIX) || !email.includes('+'),
                {
                    error: appTranslate<string>('errors.validation.email.format'),
                }
            ),
    });

export type FormSchema = z4.infer<ReturnType<typeof createSchema>>;
